import { createEffect, sample } from 'effector';
import chartsModel from 'models/charts';
import { $qInstances } from 'models/q-instances';
import navigate from 'models/router-gate';
import { z } from 'zod';

const contracts = {
    navigate: z.object({
        key: z.literal('navigate'),
        q_instance_id: z.any(),
        path: z.string(),
    }),
};

sample({
    source: chartsModel.events.eventCaught,
    filter: (event) => contracts.navigate.safeParse(event).success,
    fn: ({ q_instance_id, path }) => ({ qInstanceId: +q_instance_id, path }),
    target: chartsModel.events.navigateEventCaught,
});

sample({
    source: $qInstances,
    clock: chartsModel.events.navigateEventCaught,
    filter: (qInstances, { qInstanceId }) => qInstances[qInstanceId] !== undefined,
    fn: (qInstances, { qInstanceId, path }) => {
        const { state_code: state, questionnaire_type_code: type } = qInstances[qInstanceId];
        return `/document/${type}/${state}/${qInstanceId}?jumpTo=${path}`;
    },
    target: createEffect((path: string) => navigate(path)),
});
